
import { getApiUrl, IFacilityOccupancy } from "@app/shared";
import { useSignalr } from "@known-as-bmf/react-signalr";
import { useEffect, useCallback } from "react";
import { Subscription } from "rxjs";

const OCCUPANCY_UPDATE_EVENT = 'ReceiveOccupancy';
const WATCH_FACILITY_PARKING_COMMAND = 'WatchFacilityParking';


export function useParkingViewHub(facilityId: string | undefined, onOccupancyReceived: (o: IFacilityOccupancy) => void, unsubscribe?: boolean) {
    const { send, on } = useSignalr(getApiUrl(`/hubs/parkingview`));

    const handleOccupancyReceived = useCallback((occupancy: IFacilityOccupancy) => {
        onOccupancyReceived(occupancy)
    }, [onOccupancyReceived]);

    useEffect(() => {
        if (facilityId) {
            send(WATCH_FACILITY_PARKING_COMMAND, facilityId);
        }
    }, [facilityId, send]);

    useEffect(() => {
        let occupancySubscription: Subscription | undefined;

        if (!unsubscribe) {
            occupancySubscription = on<IFacilityOccupancy>(OCCUPANCY_UPDATE_EVENT).subscribe(handleOccupancyReceived);
        }

        return () => {
            occupancySubscription?.unsubscribe();
        }
    }, [on, unsubscribe, handleOccupancyReceived]);

}